import React from "react";
import styled from "@emotion/styled";
import useWindowSize from "../../hooks/useWindowSize";

const Title = () => {
  const size = useWindowSize();
  const DivTitle = styled.div`
    font-family: "Orbitron", sans-serif, "Franklin Gothic Medium",
      "Arial Narrow", Arial, sans-serif;
    display: flex;
    position: relative;
    align-content: center;
    @keyframes rubberBand {
      0% {
        transform: scale3d(1, 1, 1);
      }
      25% {
        transform: scale3d(1.25, 0.75, 1);
      }
      35% {
        transform: scale3d(1.3, 1, 1.25);
      }
      65% {
        transform: scale3d(0.8, 1.3, 1.1);
      }
      100% {
        transform: scale3d(1, 1, 1);
      }
    }
  `;
  const H1title = styled.h1`
    color: rgb(88, 88, 88);
    font-size: ${size.width <= 602 ? "3em " : "5em"};
    &:hover {
      animation: rubberBand 0.8s;
      color: rgb(158, 211, 245);
    }
  `;

  return (
    <div>
      <DivTitle>
        <H1title className="rubber">H</H1title>
        <H1title className="rubber">i</H1title>
        <H1title className="rubber">,</H1title>
      </DivTitle>
      <DivTitle>
        <H1title className="rubber">i</H1title>
        <H1title className="rubber">'</H1title>
        <H1title className="rubber">m</H1title>
        &nbsp; &nbsp;
        <H1title className="rubber">C</H1title>
        <H1title className="rubber">a</H1title>
        <H1title className="rubber">r</H1title>
        <H1title className="rubber">l</H1title>
        <H1title className="rubber">o</H1title>
        <H1title className="rubber">s</H1title>
        <H1title className="rubber">,</H1title>
      </DivTitle>
      <DivTitle>
        <H1title className="rubber">W</H1title>
        <H1title className="rubber">e</H1title>
        <H1title className="rubber">b</H1title>
        &nbsp; &nbsp;
        <H1title className="rubber">D</H1title>
        <H1title className="rubber">e</H1title>
        <H1title className="rubber">v</H1title>
        <H1title className="rubber">e</H1title>
        <H1title className="rubber">l</H1title>
        <H1title className="rubber">o</H1title>
        <H1title className="rubber">p</H1title>
        <H1title className="rubber">e</H1title>
        <H1title className="rubber">r</H1title>
        <H1title className="rubber">.</H1title>
      </DivTitle>
    </div>
  );
};

export default Title;
